export async function getMapCoordinates(
    address: string,
    city: string,
    postalCode: string,
    googleMapsKey: string,
) {
    const fullAddress = `${address}, ${postalCode}, ${city}`;
    const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            fullAddress,
        )}&key=${googleMapsKey}`,
    );
    const data = await response.json();

    if (data.status === "OK" && data.results.length > 0) {
        const location = data.results[0].geometry.location;
        return {
            lat: location.lat,
            lng: location.lng,
        };
    } else {
        throw new Error("Unable to retrieve coordinates from address");
    }
}
